import { useState, Fragment } from 'react';
import { Row, Col, Form } from 'antd';
import Header from './Header';
import PatientForm from './PatientForm';
import PatientServices from './PatientServices';
import Consents from './Consents';
import PatientEntry from './PatientEntry';
import SummaryServices from './SummaryServices';
import countrySettings from '../countrySettings.json';
const AdmissionSettings = ({
  id,
  reservation,
  setStartAdmission,
  patientToAdmission,
  setPatientToAdmission,
  countryCode,
  providerCode,
  laboratoryModule
}) => {
  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(0);
  const [laboratoryLoading, setLaboratoryLoading] = useState(false);

  return (
    <Fragment>
      <Row justify="center" className="admission-settings">
        <Col lg={24} xs={24}>
          <Header
            form={form}
            reservation={reservation}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            setStartAdmission={setStartAdmission}
            setPatientToAdmission={setPatientToAdmission}
          />
          {
            currentStep === 0 &&
            <PatientForm
              form={form}
              reservation={reservation}
              patientToAdmission={patientToAdmission}
              setPatientToAdmission={setPatientToAdmission}
              setCurrentStep={setCurrentStep}
              providerCode={providerCode}
              fromAdmission={true}
            />
          }
          {
            currentStep === 1 &&
            <PatientServices
              reservation={reservation}
              form={form}
              patientToAdmission={patientToAdmission}
              setPatientToAdmission={setPatientToAdmission}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              providerCode={providerCode}
              countryCode={countryCode}
              setLaboratoryLoading={setLaboratoryLoading}
              laboratoryLoading={laboratoryLoading}
              laboratoryModule={laboratoryModule}
            />
          }
          {
            currentStep === 2 &&
            <Consents
              reservation={reservation}
              patientToAdmission={patientToAdmission}
              setPatientToAdmission={setPatientToAdmission}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              countryCode={countryCode}
            />
          }
          {
            currentStep === 3 &&
            <PatientEntry
              reservation={reservation}
              patientToAdmission={patientToAdmission}
              setPatientToAdmission={setPatientToAdmission}
              currentStep={currentStep}
              setStartAdmission={setStartAdmission}
              providerCode={providerCode}
              countryCode={countryCode}
              laboratoryModule={laboratoryModule}
            />
          }
        </Col>
        <Col lg={16} xs={22}>
          {
            currentStep !== 3 && countrySettings?.showSummaryServicesInSettings?.[countryCode] && <SummaryServices id={id} />
          }
        </Col>
      </Row>
    </Fragment>
  );
};

export default AdmissionSettings;
